import { ComparatorStep } from '@kizi/comparator-core';

const checkout: ComparatorStep = {
  path: 'checkout',
  name: 'checkout',
  fields: [
    {
      name: 'orderStatus',
    },
    {
      name: 'underwritingResult',
    },
  ],
};

export default checkout;
